export function convertToIsoDate(date: any): string {
  if (date && date._isAMomentObject) {
    return date.toISOString();
  } else if (date instanceof Date) {
    return date.toISOString();
  } else if (typeof date === 'string' || typeof date === 'number') {
    const parsedDate = new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toISOString();
    } else {
      throw new Error('Invalid date format: cannot convert to Date.');
    }
  } else {
    throw new Error('Invalid date type: expected Date, Moment, string, or number.');
  }
}
